import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
  Card,
  CardHeader,
  CardText,
  Avatar,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import FormsyDate from "../forms/formComponents/FormsyDate";
import formatDate from "../../../utils/formatDate";
import FormReport from "./FormReport";

class ReportIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      formReport: true,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        dialogCenterStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "90%",
          maxHeight: window.screen.height - 512,
          overflow: "auto",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.runScript = this.runScript.bind(this);
    this.handleExpandChange = this.handleExpandChange.bind(this);
  }

  componentDidMount() {
    if (Object.keys(this.props.location.query).length > 0) {
      if (this.props.location.query.report) {
        this.handleExpandChange(this.props.location.query.report, true);
      }
    }
  }

  handleExpandChange(key, state) {
    let newState = {};
    newState[key] = state;
    this.setState(newState);
  }

  runScript(endpoint, data, displayFunction) {
    let url = endpoint;
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify({ data }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        displayFunction(json);
      });
  }

  notifyFormError(data) {
    alert("Missing Data: check that all fields are filled");
    console.error("Form error:", data);
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;

      return (
        <div>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <Card
              expanded={this.state.formReport}
              onExpandChange={(state) =>
                this.handleExpandChange("formReport", state)
              }
              zDepth={2}
              style={{ backgroundColor: "#5C6BC0", marginTop: "0.45em" }}
            >
              <CardHeader
                title="8879 Form Report"
                titleStyle={{ fontWeight: "bold", fontSize: "150%" }}
                actAsExpander={true}
                showExpandableButton={true}
              />
              <CardText
                expandable={true}
                style={{ backgroundColor: "#FAFAFA", margin: "0.5em" }}
              >
                <FormReport
                  appbar={this.props.appbar}
                  jwt={this.props.token.jwt}
                />
              </CardText>
            </Card>
          </Paper>
        </div>
      );
    }
  }
}

export default ReportIndex;



// WEBPACK FOOTER //
// ./app/components/reports/ReportIndex.js